export default __webpack_public_path__ + "static/media/ip.dc40fda1.svg";